import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Format a number as currency */
export function formatCurrency(value: number, symbol = '$', decimals = 2): string {
  return `${symbol}${value.toFixed(decimals)}`;
}

/** Format a number as a percentage */
export function formatPct(value: number, decimals = 1): string {
  return `${value.toFixed(decimals)}%`;
}

/** Format grams */
export function formatGrams(value: number): string {
  if (value >= 1000) return `${(value / 1000).toFixed(2)} kg`;
  return `${value.toFixed(1)} g`;
}
